// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"styles_subTitle__7G83m","rowContainer":"styles_rowContainer__bLsMt","confirmUploadButton":"styles_confirmUploadButton__DjlWv","container":"styles_container__fKtd6"};